import Icon from "assets/icons";
import FormContainer from "shared/form";
import Button from "shared/components/button";
import { OfflinePaymentFieldName } from "./enum";
import ButtonType from "shared/enums/ButtonTypes";
import { OfflinePaymentPropTypes } from "./types";
import { useCopies } from "shared/hooks/useCopies";
import { useOfflinePaymentService } from "./service";
import FormTextField from "shared/form/fields/textField";
import { FormikValues } from "formik";

function OfflinePayment(props: OfflinePaymentPropTypes) {
  const copies = useCopies();
  const service = useOfflinePaymentService(props);

  return (
    <div className="paymentWrapper_body">
      <div className="payment_container payment_containerOffline">
        {service.offlinePaymentNote && (
          <div
            className="payment_containerOffline--bankDetails"
            dangerouslySetInnerHTML={{ __html: service.offlinePaymentNote }}
          />
        )}
        <FormContainer
          initialValues={service.initialValues}
          onSubmit={service.submitHandler}
          enableReinitialize={true}
          validationSchema={service.validationSchema}>
          {({ values }: FormikValues) => (
            <FormContainer.Form>
              <FormTextField
                name={OfflinePaymentFieldName.PAYMENT_REFERENCE_ID}
                placeholder={copies.get("offline.payment.form.field.reference.id.placeholder")}
                label={copies.get("offline.payment.form.field.reference.id.label")}
              />
              <div className="paymentWrapper_btnWrapper">
                <Button.Save
                  label={copies.get(
                    props.offlinePaymentConfig?.offlinePaymentRequested
                      ? "offline.payment.update.reference"
                      : "offline.payment.form.btn.submit"
                  )}
                  disabled={
                    props.offlinePaymentConfig?.offlinePaymentRequested &&
                    (!values[OfflinePaymentFieldName.PAYMENT_REFERENCE_ID] ||
                      values[OfflinePaymentFieldName.PAYMENT_REFERENCE_ID] ===
                        service.initialValues[OfflinePaymentFieldName.PAYMENT_REFERENCE_ID])
                  }
                  icon={!props.offlinePaymentConfig?.offlinePaymentRequested && <Icon.Send />}
                  type={ButtonType.SUBMIT}
                />
                {props.backToOfflineRequestedClickHandler && (
                  <Button
                    isOutline
                    type={ButtonType.BUTTON}
                    label={copies.get("cancel")}
                    onClick={props.backToOfflineRequestedClickHandler}
                    className="paymentWrapper_btnWrapper--backButton"
                  />
                )}
              </div>
            </FormContainer.Form>
          )}
        </FormContainer>
      </div>
    </div>
  );
}

export default OfflinePayment;
